// extracted by mini-css-extract-plugin
export default {"resumeTip":"ResumeTips_resumeTip__wjbP0","trigger":"ResumeTips_trigger__ssNlM"};